import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_w_line_right",
  "use": "arrow_w_line_right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow_w_line_right\"><path d=\"M4.686 5v14.334H3V5zM16.512 16.973c.31.338.773.338 1.082 0L22 12.167l-4.406-4.806a.8.8 0 0 0-.54-.253.8.8 0 0 0-.542.253.867.867 0 0 0 0 1.18l2.55 2.783H7.006c-.464 0-.773.337-.773.843s.31.843.773.843h12.058l-2.55 2.783a.867.867 0 0 0 0 1.18\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol